var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "import-config": _vm.importConfig,
          "export-config": _vm.exportConfig,
          cellClick: _vm.chooseRow,
          "cell-db-click": _vm.updateRow,
        },
        on: { "toolbar-addData": _vm.addRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.synchronization()
                        },
                      },
                    },
                    [_vm._v("同步数据")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.chooseOpenPop("checkResult")
                        },
                      },
                    },
                    [_vm._v("查看发表情况")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "popModal",
        {
          attrs: {
            title: "查看发表情况",
            "pop-config": _vm.popConfig.checkResult,
          },
        },
        [
          _c("checkResult", {
            ref: "checkResult",
            attrs: {
              taskId: _vm.popConfig.checkResult.id,
              row: _vm.popConfig.checkResult.row,
              type: "checkResult",
            },
            on: { closePop: _vm.closePopAndRefresh },
          }),
        ],
        1
      ),
      _c(
        "formModal",
        { attrs: { title: "群发朋友圈", visible: _vm.editModalVisible } },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }